console.log('posts script loaded');

document.addEventListener('DOMContentLoaded', function() {
  var yearSelect = document.getElementById('sort-year');

  if (yearSelect) {
    yearSelect.addEventListener('change', function() {
      handleFormSubmission();
    });
  }

  function handleFormSubmission() {
    var selectedYear = yearSelect.options[yearSelect.selectedIndex].value;

    if (selectedYear) {
      var currentUrl = new URL(window.location.href);
      currentUrl.searchParams.set('sort-year', selectedYear);

      // Store the current scroll position
      var scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
      currentUrl.searchParams.set('scroll-position', scrollPosition);

      window.location.href = currentUrl.toString();
    }
  }

  // Restore the scroll position after the page reloads
  var scrollPositionParam = new URLSearchParams(window.location.search).get('scroll-position');
  if (scrollPositionParam) {
    window.scrollTo(0, scrollPositionParam);
  }
});
